module.exports = __webpack_public_path__ + "static/media/backdrop.b2536fe0.png";